export default __webpack_public_path__ + "images/5W.671ec7f.png";